(() => {
  const upgrade = (image) => {
    if (!image?.dataset.fsCardSrcset) return;
    image.sizes = image.dataset.fsCardSizes;
    image.srcset = image.dataset.fsCardSrcset;
    image.src = image.dataset.fsCardSrc;
    delete image.dataset.fsCardSrcset;
    delete image.dataset.fsCardSizes;
    delete image.dataset.fsCardSrc;
  };

  const primaryImages = document.querySelectorAll('[data-fs-card-primary]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        upgrade(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '120px 0px' });
    primaryImages.forEach((image) => observer.observe(image));
  } else {
    primaryImages.forEach(upgrade);
  }

  document.querySelectorAll('.product-card-wrapper:has([data-fs-card-secondary])').forEach((card) => {
    const upgradeSecondary = () => upgrade(card.querySelector('[data-fs-card-secondary]'));
    card.addEventListener('pointerenter', upgradeSecondary, { once: true });
    card.addEventListener('focusin', upgradeSecondary, { once: true });
  });
})();
